(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["spots-coming-soon"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('spots-coming-soon')) {
 customElements.define('spots-coming-soon',class extends HTMLElement {
  connectedCallback() {
   if(this.controller) return;
   this.controller=new AbortController();
   const track=this.querySelector('.spots-coming-soon__track');
   const buttons=Array.from(this.querySelectorAll('[data-slide]'));
   const options={signal:this.controller.signal};
   const update=()=>{
    const index=matchMedia('(max-width:699px)').matches?Math.round(track.scrollLeft/track.clientWidth):0;
    buttons.forEach((button,i)=>button.setAttribute('aria-current',String(i===index)));
   };
   buttons.forEach((button,i)=>button.addEventListener('click',()=>{
    track.scrollTo({left:i*track.clientWidth,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'});
   },options));
   track.addEventListener('scroll',update,{...options,passive:true});
   window.addEventListener('resize',update,options);
   update();
  }
  disconnectedCallback() { this.controller?.abort();this.controller=null; }
 });
}

  } catch(e) { console.error(e); }
})();
})();
